<template>
    <div>
        <div class="table-control">
            <table class="table">
                <colgroup>
                    <col style="width:100px;">
                    <col>
                </colgroup>
                <tbody>
                    <tr v-if="action.title">
                        <td><strong>Title</strong></td>
                        <td>{{action.title}}</td>
                    </tr>
                    <tr v-for="(email, emailIndex) in action.emails" :key="emailIndex">
                        <td colspan="2">
                            <div class="table-control">
                                <h3>Email #{{emailIndex + 1}}</h3>
                                <table>
                                    <tbody>
                                        <tr v-for="(line, lineIndex) in lines" :key="lineIndex">
                                            <td><strong class="text-muted">{{line[0]}}</strong></td>
                                            <td>{{line[1](email)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import BaseActionSummary from '../base-action-summary';

    export default {
        name: 'send-email-summary',
        extends: BaseActionSummary,
        data() {
            return {
                lines: [
                    ['From', v => v.from],
                    ['To', v => v.to.join(', ')],
                    ['Subject', v => v.subject],
                ],
            };
        },
    };
</script>
